<template>
    <div class="relative">
        <div class="px-8 pb-12">
            <div class="splide" id="upsale-slide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(campaign, k) in campaigns"
                            :key="k"
                            >
                            <div class="rounded-20 p-1 bg-white">
                                <div>
                                    <div class="campaign-image" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
                                </div>
                                <div class="flex w-full pt-2">
                                    <div class="text-14 lg:text-16 ml-0 mr-auto">{{campaign.name}}</div>
                                    <div clase="font-bold text-14 lg:text-16 ml-auto mr-0">{{FilterNumberFormat(campaign.pricePerUnit)}} Bath</div>
                                </div>
                                <div class="flex py-2">
                                    <img class="mr-0 ml-auto h-5" @click="clickReduce(k)" v-if="campaign.quantity == 0 || !campaign.quantity" src="@/assets/icon/ic-delete-black.svg" />
                                    <img class="mr-0 ml-auto h-5" @click="clickReduce(k)" v-else src="@/assets/icon/ic-delete-red.svg" />
                                    <div class="mx-4 text-14 lg:text-16 my-auto">{{FilterNumberFormat(campaign.quantity)}}</div>
                                    <img class="mr-auto ml-0 h-5"  @click="clickAdd(k)" src="@/assets/icon/ic-add-red.svg" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="absolute top-1/3 w-full flex">
            <button class="mr-auto -ml-2" @click="btnPrev()">
                <img src="@/assets/icon/ic-nav-left-brown.svg" />
            </button>
            <button class="-mr-2 ml-auto" @click="btnNext()">
                <img src="@/assets/icon/ic-nav-right-brown.svg" />
            </button>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
// import Util from '@/helper/Utility.js';
// import Locale from "@/helper/locale/Locale.js";
//service

/**
 * @event onLoaded
 */
export default {
    name: "UpsaleSlider",
    props: {
        campaigns: { type: Array, required: true },
    },
    data: function() {
        return {
            reload: false,
            slider: null,
            currentSliderIndex: 0,
        };
    },
    created: function() {
        //this.getDashboard();
        this.setSlider();
    },
    methods: {
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#upsale-slide', {
                    type: 'loop',
                    arrows: false,
                    gap: '10px'
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },

        btnNext: function() {
            let next = this.currentSliderIndex + 1;
            this.slider.go(next);
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1;
            this.slider.go(prev);
        },

        clickAdd: function(index) {
            if(!this.campaigns[index].quantity) {
                this.campaigns[index].setQuantity(1);
            } else {
                this.campaigns[index].setQuantity(this.campaigns[index].quantity + 1);
            }
            this.$emit('itemUpdate');
        },
        clickReduce: function(index) {
            if (this.campaigns[index].quantity != 0) {
                if(!this.campaigns[index].quantity) {
                    this.campaigns[index].setQuantity(0);
                } else {
                    this.campaigns[index].setQuantity(this.campaigns[index].quantity - 1);
                }
            }
            this.$emit('itemUpdate');
        },
    },
}
</script>
<style lang="scss">
    #upsale-slide {
        .splide__pagination {
            bottom: -24px;
            .splide__pagination__page {
                background-color: #502314;
                opacity: 0.3;
                width: 6px;
                height: 6px;
                &.is-active {
                    opacity: 1;
                    background-color: #502314;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
        border-radius: 17px;
    }
</style>
